import axios from 'axios';
import AuthService from 'services/AuthService';

const HTTP = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL
});

HTTP.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem(config.url === '/api/web/auth/refreshToken' ? 'refresh_token' : 'access_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    }, (error) => {
        Promise.reject(error);
    }
);

// This allows you to intercept the response and check the status and error messages and if necessary reject the promise.
HTTP.interceptors.response.use(
    (response) => {
        return response.data;
    },
    async (error) => {
        console.error(error);
        const originalRequest = error.config;
        const refresh_token = localStorage.getItem('refresh_token');
        if ((error.response && error.response.status === 401) && !originalRequest._retry && refresh_token) {
            originalRequest._retry = true;
            try {
                const tokenResponse = await AuthService.refresh();
                const { accessToken } = tokenResponse.data;
                localStorage.setItem('access_token', accessToken);
                originalRequest.headers.Authorization = `Bearer ${accessToken}`;
                return axios(originalRequest);
            } catch (error) {
                if (error.response.status === 401) {
                    window.localStorage.clear();
                    window.location.href = '/login';
                } else {
                    return Promise.reject(error);
                }
            }
        } else {
            return Promise.reject(error);
        }
    }
);

export { HTTP };
